import React from "react";
import { FaExternalLinkAlt, FaSave, FaSpinner } from "react-icons/fa";

export default function PageLivePreview({ page, html, onSave, saving }) {
  const publicUrl = page?.slug ? `/pages/${page.slug}` : "";

  return (
    <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="border-b border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/70">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
              Aperçu en direct
            </div>

            <h2 className="mt-1 text-lg font-bold text-slate-950 dark:text-slate-50">
              {page?.title || "Page"}
            </h2>

            {publicUrl ? (
              <div className="mt-1 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
                <span>{publicUrl}</span>
                <FaExternalLinkAlt />
              </div>
            ) : null}
          </div>

          <button
            type="button"
            onClick={onSave}
            disabled={saving}
            className="inline-flex items-center gap-2 rounded-2xl bg-slate-950 px-4 py-2.5 text-xs font-bold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-slate-100 dark:text-slate-950 dark:hover:bg-white"
          >
            {saving ? <FaSpinner className="animate-spin" /> : <FaSave />}
            Sauver
          </button>
        </div>
      </div>

      <div className="bg-slate-100 p-3 dark:bg-slate-950">
        <div className="mx-auto max-h-[calc(100vh-230px)] overflow-auto rounded-[28px] border border-slate-200 bg-white dark:border-slate-800">
          {html ? (
            <div
              className="cms-page-preview"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : (
            <div className="p-8 text-sm text-slate-500 dark:text-slate-400">
              Ajoutez des blocs pour voir le rendu de la page.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}